import { Navigate, useLocation } from "react-router-dom";
import { useAuth, roleHome } from "../lib/auth";

export function ProtectedRoute({ allow, children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div data-testid="auth-loading" className="min-h-screen bg-mb-bg text-mb-fg2 flex items-center justify-center">
        <div className="animate-pulse text-sm tracking-widest uppercase">loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (allow && !allow.includes(user.role)) return <Navigate to={roleHome(user.role)} replace />;
  return children;
}
